import React from "react";

const Button = ({
  disabled = false,
  loading = false,
  label = "",
  startIcon,
  onClick = () => {},
  className,
  type = "button",
  collapse = true,
  style = {},
}) => {
  const classes = ["s-button"];
  if (className) classes.push(className);
  if (loading && collapse) classes.push("loading");
  if (disabled) classes.push("disabled");

  return (
    <button
      type={type}
      disabled={disabled}
      className={classes.join(" ")}
      onClick={onClick}
      style={style}
    >
      {/*{startIcon && startIcon}*/}
      {loading ? <span className="spinner" /> : label}
      <span style={{ visibility: "hidden" }}>.</span>
    </button>
  );
};

export default Button;
